let initialState = null;

function notification(state = initialState, action) {
  if (action.type === "NOTIFICATION_VIEWED") {
    return action.res;
  } else return state;
}

export default notification;
